import { useEffect } from 'react';

const DynamicFavicon = ({ logoImageUrl }) => {
  useEffect(() => {
    if (!logoImageUrl || logoImageUrl === 'none') {
      return;
    }

    // Функция для установки прямой ссылки на изображение как favicon
    const setDirectImageAsFavicon = () => {
      // console.log('Используем прямую ссылку на изображение как favicon');

      // Устанавливаем прямую ссылку на изображение как favicon
      let mainFavicon = document.querySelector('link[rel="icon"]:not([sizes])');
      if (!mainFavicon) {
        mainFavicon = document.createElement('link');
        mainFavicon.rel = 'icon';
        document.head.appendChild(mainFavicon);
      }
      mainFavicon.href = logoImageUrl;

      // Также устанавливаем для разных размеров
      const faviconSizes = [16, 32, 48];
      faviconSizes.forEach((size) => {
        let faviconLink = document.querySelector(`link[rel="icon"][sizes="${size}x${size}"]`);
        if (!faviconLink) {
          faviconLink = document.createElement('link');
          faviconLink.rel = 'icon';
          faviconLink.sizes = `${size}x${size}`;
          document.head.appendChild(faviconLink);
        }
        faviconLink.href = logoImageUrl;
      });

      // Apple Touch Icon
      let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        document.head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.href = logoImageUrl;
    };

    // Сразу используем прямую ссылку на изображение
    setDirectImageAsFavicon();
  }, [logoImageUrl]);

  // Компонент не рендерит ничего видимого
  return null;
};

export default DynamicFavicon;
